"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visualizationModeCheck = exports.showReceiveOfferForm = exports.showItemIdentifier = exports.showCallToAction = exports.isSelectedAmountsUpdated = exports.isFallbackVisualizationMode = exports.isDesignerProductPreviewMode = exports.isCalculationAutoResolveEnabled = exports.hasMultipleVariantsSelected = exports.getVisualizationSettings = exports.getUserSelectedCalculation = exports.getShareUrl = exports.getSelectedVariantIdentifier = exports.getSelectedAmounts = exports.getItemSettings = exports.getItem = exports.getDeepestChildIdentifiers = exports.getCurrentVisualizationSettings = exports.getConfigurator = exports.getConfigurationSettings = exports.getConfiguration = exports.getClientTexts = exports.getClientHighlightColor = exports.getClient = exports.getChildren = exports.getCallToAction = exports.getCalculation = exports.getBulkNames = exports.findMaxChildrenCount = exports.createCalculationErrorChecker = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _flow = _interopRequireDefault(require("lodash/flow"));
var _find = _interopRequireDefault(require("lodash/find"));
var _difference = _interopRequireDefault(require("lodash/difference"));
var _keys = _interopRequireDefault(require("lodash/keys"));
var _values = _interopRequireDefault(require("lodash/values"));
var _createSelector = _interopRequireDefault(require("../../../Utils/Function/createSelector"));
var _Selectors = require("../ConfigurationMode/Selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getConfigurator = exports.getConfigurator = function getConfigurator(rootState) {
  return rootState.configurator;
};
var getConfiguration = exports.getConfiguration = function getConfiguration(configuratorState) {
  return (0, _get["default"])(configuratorState, 'configuration');
};
var getCalculation = exports.getCalculation = function getCalculation(configuratorState) {
  return (0, _get["default"])(configuratorState, 'calculation');
};
var getSelectedVariantIdentifier = exports.getSelectedVariantIdentifier = function getSelectedVariantIdentifier(configuratorState) {
  return (0, _get["default"])(configuratorState, 'selectedVariantIdentifier');
};
var getClient = exports.getClient = function getClient(configuratorState) {
  return (0, _get["default"])(configuratorState, 'client');
};
var getItem = exports.getItem = (0, _createSelector["default"])(getConfiguration, function (configuration) {
  return (0, _get["default"])(configuration, 'item');
});
var getUserSelectedCalculation = exports.getUserSelectedCalculation = (0, _createSelector["default"])(getConfiguration, function (configuration) {
  return (0, _get["default"])(configuration, 'customdata.userSelectedCalculation');
});
var getSelectedAmounts = exports.getSelectedAmounts = (0, _createSelector["default"])(getConfiguration, function (configuration) {
  return (0, _get["default"])(configuration, 'customdata.selectedAmounts');
});
var getBulkNames = exports.getBulkNames = (0, _createSelector["default"])(getConfiguration, function (configuration) {
  return (0, _get["default"])(configuration, 'customdata.bulkNames') || [];
});
var getShareUrl = exports.getShareUrl = (0, _createSelector["default"])(getConfiguration, function (configuration) {
  return (0, _get["default"])(configuration, 'shareUrl', '') || '';
});
var getChildren = exports.getChildren = (0, _createSelector["default"])(getItem, function (item) {
  return (0, _get["default"])(item, 'itemGroup.children') || [];
});
var getItemSettings = exports.getItemSettings = (0, _createSelector["default"])(getItem, function (item) {
  return (0, _get["default"])(item, 'settings', {});
});
var getVisualizationSettings = exports.getVisualizationSettings = (0, _createSelector["default"])(getItemSettings, function (settings) {
  return {
    creator: (0, _get["default"])(settings, 'visualizationCreator'),
    designer: (0, _get["default"])(settings, 'visualizationDesigner')
  };
});
var findMaxChildrenCount = exports.findMaxChildrenCount = function findMaxChildrenCount(item) {
  var children = (0, _get["default"])(item, 'itemGroup.children') || [];
  return Math.max(children.length, children.length && findMaxChildrenCount(children[0]));
};
var getCurrentVisualizationSettings = exports.getCurrentVisualizationSettings = (0, _createSelector["default"])((0, _flow["default"])(getConfigurator, getVisualizationSettings), _Selectors.getSelectedConfigurationMode, function (visualizationSettings, configurationMode) {
  return visualizationSettings[configurationMode] || 'default';
});
var visualizationModeCheck = exports.visualizationModeCheck = (0, _flow["default"])(getCurrentVisualizationSettings, function (mode) {
  return {
    is2D: function is2D() {
      return mode === '2dVariant' || mode === '2dVariantOverlay' || mode === '2dLayer' || mode === '2d' || mode === 'layer';
    },
    is3D: function is3D() {
      return mode === '3dVariant' || mode === '3dScene' || mode === '3d';
    },
    is2DOverlay: function is2DOverlay() {
      return mode === '2dVariantOverlay';
    },
    isDefault: function isDefault() {
      return mode === 'default';
    }
  };
});
var isSelectedAmountsUpdated = exports.isSelectedAmountsUpdated = function isSelectedAmountsUpdated(configuratorState) {
  return (0, _get["default"])(configuratorState, 'selectedAmountsUpdated');
};
var hasMultipleVariantsSelected = exports.hasMultipleVariantsSelected = function hasMultipleVariantsSelected(state) {
  var item = state.configuration.item;
  var selectedAmounts = getSelectedAmounts(state);
  var selectedVariantKeys = (0, _keys["default"])(selectedAmounts);
  // get the firstSelectedAmountVariant and compare remaining to firstSelectedAmountVariant identifiers
  if (selectedVariantKeys.length > 1) {
    var firstSelectedVariant = (0, _find["default"])((0, _get["default"])(item, 'itemGroup.children'), {
      identifier: selectedVariantKeys[0]
    });
    if (!firstSelectedVariant) {
      return false;
    }
    if (!(0, _get["default"])(firstSelectedVariant, 'itemGroup.children')) {
      return true;
    }
    var multipleVariants = (0, _difference["default"])((0, _keys["default"])(selectedAmounts), (0, _values["default"])(getDeepestChildIdentifiers(firstSelectedVariant)));
    if (multipleVariants.length > 0) {
      return true;
    }
  }
  return false;
};
var getDeepestChildIdentifiers = exports.getDeepestChildIdentifiers = function getDeepestChildIdentifiers(item) {
  if (!item.itemGroup || !item.itemGroup.children) {
    return _defineProperty({}, item.itemgroupentryIdentifier, item.identifier);
  }
  var result = {};
  var _iterator = _createForOfIteratorHelper(item.itemGroup.children),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;
      Object.assign(result, getDeepestChildIdentifiers(child));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
};
var createCalculationErrorChecker = exports.createCalculationErrorChecker = function createCalculationErrorChecker(configuratorState) {
  var calculation = getCalculation(configuratorState);
  var errorCode = (0, _get["default"])(calculation, 'code');
  return {
    isMinOrderAmountError: function isMinOrderAmountError() {
      return errorCode === 'minimum_order_amount_error';
    }
  };
};
var getClientHighlightColor = exports.getClientHighlightColor = function getClientHighlightColor(state) {
  return (0, _get["default"])(getClient(getConfigurator(state)), 'theme.highlightColor');
};
var getClientTexts = exports.getClientTexts = function getClientTexts(configuratorState) {
  return (0, _get["default"])(getClient(configuratorState), 'texts') || {};
};
var isCalculationAutoResolveEnabled = exports.isCalculationAutoResolveEnabled = function isCalculationAutoResolveEnabled(_ref2) {
  var calculationAutoResolve = _ref2.calculationAutoResolve;
  return calculationAutoResolve === true;
};
var isDesignerProductPreviewMode = exports.isDesignerProductPreviewMode = function isDesignerProductPreviewMode() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.pathname;
  return /\/designer-preview-widget\/?/.test(pathname);
};
var getConfigurationSettings = exports.getConfigurationSettings = (0, _createSelector["default"])(getConfiguration, function (configuration) {
  return (0, _get["default"])(configuration, 'information.settings', {});
});
var showItemIdentifier = exports.showItemIdentifier = (0, _createSelector["default"])(getConfigurationSettings, function (settings) {
  return (0, _get["default"])(settings, 'show_item_identifier', false);
});
var getCallToAction = exports.getCallToAction = (0, _createSelector["default"])(getItem, function (item) {
  return (0, _get["default"])(item, 'callToAction', 'addToBasket');
});
var showCallToAction = exports.showCallToAction = (0, _createSelector["default"])(getCallToAction, function (callToAction) {
  return callToAction !== 'none';
});
var showReceiveOfferForm = exports.showReceiveOfferForm = (0, _createSelector["default"])(getCallToAction, function (callToAction) {
  return callToAction === 'requestOffer';
});
var isFallbackVisualizationMode = exports.isFallbackVisualizationMode = function isFallbackVisualizationMode(state) {
  return 'fallback' === getCurrentVisualizationSettings(state);
};